import * as Yup from "yup";

export const initialValues = {
  workTypeId: null,
  durationType: "ALLDAY",
  startDate: null,
  endDate: null,
  startTime: "00:00:00",
  endTime: "00:00:00",
  description: null,
};

const OffsiteSchema = Yup.object().shape({
  workTypeId: Yup.string().required("Please select."),
  startDate: Yup.string().required("Please select."),
  endDate: Yup.string().required("Please select."),
  description: Yup.string().required("Please enter."),
  durationType: Yup.string().required("Please select durationType."),
});

export default OffsiteSchema;
